import type { IExercise } from '../exercises';

export const FANJUE_EPISODE_13_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-fanjue-plan-13-01",
    "name": "反向山羊挺身卷腹",
    "bodyPart": "abs",
    "equipment": "bodyweight",
    "subCategory": "lower-abs",
    "tips": ["下背部+下腹复合", "控制幅度"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": true,
    "demoUrl": "/media/collections-20261008/demos/1999a4fa23d76c7db58da5e1.mp4",
    "videoUrl": "/media/collections-20261008/videos/8be7f92cb14e8c5f57e77228.mp4",
    "targetMuscles": ["腹直肌上部", "腹直肌下部"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第13期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-13-02",
    "name": "悬垂举腿",
    "bodyPart": "abs",
    "equipment": "bodyweight",
    "subCategory": "lower-abs",
    "tips": ["核心发力带动腿部抬起", "不借力摆动"],
    "sets": 3,
    "reps": "12",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": true,
    "source": "焚诀计划 · 第13期",
    "demoUrl": "/media/collections-20261008/demos/5a6f112e677f6c91e830c6c7.mp4",
    "videoUrl": "/media/collections-20261008/videos/3e3bac976c6e1d2e9b4257db.mp4",
    "targetMuscles": ["腹直肌下部"],
    "difficulty": "beginner",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-13-03",
    "name": "跪姿龙门架磕头",
    "bodyPart": "abs",
    "equipment": "cable",
    "subCategory": "upper-abs",
    "tips": ["绳索卷腹", "上腹顶峰收缩"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/reviewed-5b5e235f3aa737779469918d.mp4",
    "videoUrl": "/media/collections-20261008/videos/5f42c2c9782933fd603abb27.mp4",
    "targetMuscles": ["腹直肌上部"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第13期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
];
